/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
export const populateStringVariables = (str: string, data: any) => {
    let s = str
    for (const prop in data) {
        s = s.replace(new RegExp("{"+ prop +"}", "g"), data[prop])
    }
    return s
}


// WEBPACK FOOTER //
// ./src/utils/string/utils.ts